import { Navbar } from 'react-bootstrap';
import s from './HeaderLogo.module.scss';
import { classNames } from '/shared/lib/classNames/classNames';
import { Icon } from '/shared/ui/Icon';
import headerLogo from '/shared/assets/img/header-logo.svg?react';

interface HeaderLogoProps {
  className?: string;
}

export const HeaderLogo = ({ className }: HeaderLogoProps) => {
  return (
    <Navbar.Brand
      className={classNames(s.HeaderLogo, {}, [className])}
      href='https://c.bal-inf.ru'
      target='_blank'
      draggable='false'
    >
      <Icon Svg={headerLogo} />
    </Navbar.Brand>
  );
};
